import * as z from "zod";
import { RecognizeAudienceDateRange } from "./audience-date-range";
import { RecognizeAudienceOrderCount } from "./audience-order-count";
import { RecognizeAudienceProduct } from "./audience-product";
import { RecognizeVipCriterion, RecognizeVipProfile } from "./vip-profile";

export const RecognizeExportProfile = z.object({
  id: RecognizeVipProfile.shape.id,
  identifiedAt: z.string(),
  provider: z.string(),
  providerCustomerId: z.string().nullable(),
  contact: z.object({
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    full_name: z.string().nullable(),
    email: z.string().nullable(),
    normalized_email: z.string().nullable(),
    phone: z.string().nullable(),
    normalized_phone: z.string().nullable(),
    shipping_name: z.string().nullable(),
    shipping_address1: z.string().nullable(),
    shipping_address2: z.string().nullable(),
    shipping_city: z.string().nullable(),
    shipping_state: z.string().nullable(),
    shipping_postal_code: z.string().nullable(),
    shipping_country: z.string().nullable(),
    billing_name: z.string().nullable(),
    billing_address1: z.string().nullable(),
    billing_address2: z.string().nullable(),
    billing_city: z.string().nullable(),
    billing_state: z.string().nullable(),
    billing_postal_code: z.string().nullable(),
    billing_country: z.string().nullable(),
  }),
  input: z.record(z.string(), z.unknown()),
  results: z.array(z.record(z.string(), z.unknown())),
  verdicts: z.array(
    z.object({
      criterion: z.string(),
      outcome: z.string(),
      reason: z.string(),
    }),
  ),
  customerSince: z.string(),
  orders: RecognizeVipProfile.shape.orders,
  orderStats: RecognizeVipProfile.shape.orderStats,
});
export type RecognizeExportProfile = z.infer<typeof RecognizeExportProfile>;

export const RecognizeExportFormat = z.enum(["full", "meta", "google"]);
export type RecognizeExportFormat = z.infer<typeof RecognizeExportFormat>;

export const RecognizeExportFilters = z.object({
  segment: z.enum(["all", "vips", ...RecognizeVipCriterion.options]),
  search: z.string().trim(),
  products: RecognizeAudienceProduct.array().min(1).optional(),
  orderCount: RecognizeAudienceOrderCount.optional(),
  dateRange: RecognizeAudienceDateRange.optional(),
});

export const RecognizeExportOptions = RecognizeExportFilters.extend({
  rowLimit: z.number().int().positive().max(Number.MAX_SAFE_INTEGER).nullable(),
});
